/** The EPUB worker started from its bundle under the app's Trusted Types policy (part 20; part 15, table T). */
import type { WorkerSource } from '../preview/platform.ts';
import type { EpubWorker } from './controller.ts';

/** T6, T7: a function starting an EPUB worker (a module worker) for each export. */
export function epubWorker(source: WorkerSource<EpubWorker>): (store: string) => EpubWorker {
  // Part 36a, table BK10: named by the book store it reads, which the worker opens by that name.
  return (store) => new source.Worker(source.trusted(source.url), { type: 'module', name: store });
}
